import { useContext } from 'react'

import { WidgetContext } from '../../../../context'

export function useWidgetContext() {
  const context = useContext(WidgetContext)

  return context
}
